import { useStyles } from './Tickets.styles';
import { LogoSvg } from '@assets/index';
import { Box, Paper } from '@mui/material';
import type { ReactNode } from 'react';

export const TicketContainer = ({ children }: { children?: ReactNode }) => {
  const classes = useStyles();

  return (
    <div className={classes.landing}>
      <Paper className={classes.paperLanding}>
        <Box className={classes.textDisplay}>
          <LogoSvg />
        </Box>
        {children}
      </Paper>
    </div>
  );
};